import { Injectable } from '@angular/core';
import { Observable, from, catchError, map, of, switchMap } from 'rxjs';
import { CanvaTemplate, CANVA_TEMPLATES } from '../data/canva-templates';
import { environment } from 'src/environments/environment';

interface S3CanvaTemplate {
  canvaDesignId: string;
  title: string;
  category: string;
  thumbnailUrl: string | null;
  canvaUrl: string;
  sortOrder: number;
}

@Injectable({ providedIn: 'root' })
export class CanvaTemplateService {

  /**
   * Returns the curated templates from the local static list (canva-templates.ts).
   *
   * NOTE: the S3/Canva API fetch is commented out for now — we don't have any
   * templates beyond the curated static list yet, so there's no point calling the
   * API on every page open. The synced Canva templates have been folded into the
   * static CANVA_TEMPLATES list, which is now the single source of truth.
   * Re-enable the fetch below (and syncThenLoad) once dynamic templates return.
   */
  getTemplates(): Observable<CanvaTemplate[]> {
    return of(CANVA_TEMPLATES);

    // --- API fetch disabled (see note above) ---
    // const url = (environment as any).canvaTemplatesUrl as string | undefined;
    // if (!url) {
    //   return of(CANVA_TEMPLATES);
    // }
    //
    // return from(
    //   fetch(url).then((r) => {
    //     if (!r.ok) throw new Error(`HTTP ${r.status}`);
    //     return r.json() as Promise<S3CanvaTemplate[]>;
    //   })
    // ).pipe(
    //   map((items) => {
    //     if (!items?.length) return CANVA_TEMPLATES;
    //     const synced = items.map((item) => ({
    //       id: item.canvaDesignId,
    //       title: item.title,
    //       category: this.normaliseCategory(item.category),
    //       previewImage: item.thumbnailUrl || 'assets/images/default_cover.png',
    //       canvaUrl: item.canvaUrl,
    //     }));
    //     // Merge in the curated static templates (e.g. corporate/holiday) that
    //     // aren't yet part of the synced Canva folder.
    //     const syncedIds = new Set(synced.map((t) => t.id));
    //     return [...synced, ...CANVA_TEMPLATES.filter((t) => !syncedIds.has(t.id))];
    //   }),
    //   catchError(() => of(CANVA_TEMPLATES))
    // );
  }

  /**
   * Previously triggered a Canva folder sync on the Lambda then fetched the
   * updated list. Sync is disabled for now — just returns the static list via
   * getTemplates() so no API call is made. Re-enable when dynamic templates return.
   */
  syncThenLoad(): Observable<CanvaTemplate[]> {
    return this.getTemplates();

    // --- Canva sync disabled (see note above) ---
    // const apiUrl  = (environment as any).canvaApiUrl  as string | undefined;
    // const folderId = (environment as any).canvaFolderId as string | undefined;
    //
    // if (!apiUrl || !folderId) return this.getTemplates();
    //
    // return from(
    //   fetch(`${apiUrl}?action=sync`, {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ folderId }),
    //   }).then((r) => { if (!r.ok) throw new Error(`Sync HTTP ${r.status}`); })
    // ).pipe(
    //   switchMap(() => this.getTemplates()),
    //   catchError(() => this.getTemplates())
    // );
  }

  private normaliseCategory(raw: string): 'wedding' | 'birthday' | 'corporate' | 'holiday' | 'other' {
    const lower = (raw ?? '').toLowerCase();
    if (lower.includes('wedding')) return 'wedding';
    if (lower.includes('birthday')) return 'birthday';
    if (lower.includes('corporate') || lower.includes('company') || lower.includes('business')) return 'corporate';
    if (lower.includes('holiday') || lower.includes('christmas') || lower.includes('new year')) return 'holiday';
    return 'other';
  }
}
